import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateUserRefreshTable } from "../../../redux/users/userSlice";
import UsersCreateEditForm from "./UsersCreateEditForm";
import { FormAction } from "../../../types/enums";

export default function UsersCreate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateToUsersAndRefresh = () => {
    dispatch(updateUserRefreshTable(true));
    setTimeout(() => {
      dispatch(updateUserRefreshTable(false));
    }, 1000);
    navigate("/organization-management/users");
  };

  return (
    <UsersCreateEditForm
      mode={FormAction.Create}
      onSaveSuccess={navigateToUsersAndRefresh}
      onCancel={() => navigate("/organization-management/users")}
    />
  );
}
